import { defaultSections, type SectionName, type SectionVisibility } from './constants';

/**
 * Returns the sections that should be visible based on the AEM data
 * If we set allowed sections, we only show those
 * If we set blocked sections, we wont show those
 */
export function getVisibleSections(allow?: SectionName[], block?: SectionName[]): SectionVisibility {
  return Object.fromEntries(
    defaultSections.map((section) => [
      section,
      !(
        (allow && !allow?.includes(section)) || //
        (block && block?.includes(section))
      ),
    ]),
  ) as SectionVisibility;
}

export function createLazyLoadIO(element: Element, rootMargin: string, loadedFn: () => void) {
  const lazyLoadingIO = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        loadedFn();
        lazyLoadingIO.disconnect(); // kill the observer after the first load for performance
      }
    },
    { rootMargin },
  );
  lazyLoadingIO.observe(element);
  return lazyLoadingIO;
}

let ro: ResizeObserver | undefined;

/**
 * Scroll to the anchor element with the given hash
 */
export function scrollToAnchor(urlHash: string) {
  // if we are already scrolling, we just disconnect the previous observer
  ro?.disconnect();
  const anchorElement = document.querySelector(`a${urlHash}`);
  if (!anchorElement) return;

  // we may still be loading the content, and height may change and we will scroll to the wrong position
  // so we use a ResizeObserver to scroll again when the content is loaded
  ro = new ResizeObserver(() => anchorElement?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
  ro.observe(document.body);

  // after 2 seconds we just disconnect the observer to avoid memory leaks and we hope everything is now loaded
  setTimeout(() => {
    ro?.disconnect();
    ro = undefined;
  }, 2000);
}
